import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import BasePage from '@src/basePage';
import { LX_PERSONAL_CENTER_VIEW, PAGE_NAME } from '@common/const';
import { Button, Modal, notification } from '@ss/mtd-react';
import { useRequest } from 'ahooks';
import useGo from '@utils/navigate';
import { unBindWechat, validaPhone } from '@src/service';
import { appKey } from '@src/enums';
import BindOrExchangePhone, { BindPhoneTypeEnum } from '@elements/BindOrExchangePhone';
import { LxSiteClick, LxPageView } from '@utils/siteLx';
import { useRootStore } from '@src/model';
import { isString } from '@block/utils';
import './index.scss';

function showNickName(nickName) {
  if (!nickName || !isString(nickName)) {
    return ['未绑定'];
  }
  let newNickName = nickName;
  let result = null;
  let rightContext = null;
  const domList: JSX.Element[] = [];
  // 提取微信名称中的表情符号进行展示 如：&#127752;
  // eslint-disable-next-line no-cond-assign
  while ((result = newNickName.match(/&#\d+;/))) {
    const leftContext = newNickName.slice(0, (result as { index: number }).index);
    const context = result[0];
    if (leftContext) {
      domList.push(<span>{leftContext}</span>);
    }
    domList.push(<span dangerouslySetInnerHTML={{ __html: context }} />);
    rightContext = newNickName.slice((result as { index: number }).index + (context as string).length);
    newNickName = rightContext;
  }
  if (rightContext) {
    domList.push(<span>{rightContext}</span>);
  }
  if (Array.isArray(domList) && domList.length > 0) {
    return domList;
  }
  return [nickName];
}

function AccountSetting() {
  const { loginStore } = useRootStore();
  const [btnLoading, setBtnLoading] = useState(false);
  const { userInfo } = loginStore;

  const { go } = useGo();
  const { runAsync: runUnbindWechat } = useRequest(unBindWechat, { manual: true });
  const { runAsync: runValidPhone } = useRequest(validaPhone, { manual: true });

  useEffect(() => {
    LxPageView({ cid: LX_PERSONAL_CENTER_VIEW.accountSetting });
  }, []);

  // 解除绑定 统一跳转至登录页
  const removeBind = () => {
    LxSiteClick({ bid: 'b_ead_xxwbafd5_mc' });
    Modal.confirm({
      className: 'common_modal',
      style: { width: 430, minHeight: 196 },
      title: '解除绑定',
      closable: true,
      message: '确认解除微信号绑定吗？',
      cancelBtnProps: { size: 'large' },
      okBtnProps: { type: 'warning', size: 'large' },
      onOk: async () => {
        // 解绑判断当前登录用户，是否该手机号
        await runUnbindWechat({ appKey, originalAccountId: userInfo?.accountId });
        notification.success({
          message: '解绑成功',
        });
        go('/login');
      },
    });
  };

  // 更换手机号
  const exchangePhone = async () => {
    LxSiteClick({ bid: 'b_ead_i1o33nic_mc' });
    try {
      setBtnLoading(true);
      const res = await runValidPhone({
        originalAccountId: userInfo?.accountId,
      }); // 先校验手机号是否可以修改
      if (!res) {
        notification.error({
          title: '错误',
          message: '当前手机号异常，请联系工作人员处理',
        });
        return;
      }
      const dialog = Modal.confirm({
        className: 'common_modal no_footer',
        style: { width: 430, minHeight: 314 },
        title: '更换手机',
        maskClosable: false,
        closable: true,
        message: (
          <BindOrExchangePhone
            type={BindPhoneTypeEnum.exchange}
            onClose={() => {
              dialog.close();
            }}
            onConfirm={() => {
              dialog.close();
              go('/login');
            }}
          />
        ),
        okText: false,
        cancelText: false,
      });
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="account_setting">
      {userInfo?.phone && (
        <div className="account_setting_item">
          <div className="left">
            <img src={require('@imgs/phone.svg')} alt="" />
            <div className="userinfo">
              <div className="name">手机号</div>
              <div className="code">{userInfo.phone}</div>
            </div>
          </div>
          <div className="right">
            <Button onClick={exchangePhone} loading={btnLoading}>
              更换手机
            </Button>
            <div className="tips">更换后，简历中的手机号码也将同步更换</div>
          </div>
        </div>
      )}
      <div className="account_setting_item">
        <div className="left">
          <img src={require('@imgs/weixin.svg')} alt="" />
          <div className="userinfo">
            <div className="name">微信号</div>
            {userInfo?.bindWechat && userInfo?.nickName && (
              <div className="code">{showNickName(userInfo.nickName)}</div>
            )}
            {userInfo?.bindWechat && !userInfo?.nickName && <div className="code">已绑定</div>}
            {!userInfo?.bindWechat && <div className="code">未绑定</div>}
          </div>
        </div>
        {userInfo?.bindWechat && (
          <div className="right">
            <Button onClick={removeBind}>解除绑定</Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default BasePage(observer(AccountSetting), PAGE_NAME.resumeDetail);
